/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './MapControls.scss';

import { type Map } from 'mapbox-gl';

import { MapExpandButton, MapLoadingIndicator, MapZoomControls } from 'shared-ui/map';

import { SearchFilterCombo } from '../SearchFilterCombo/SearchFilterCombo';

interface MapControlsProps {
    mapInstance: Map | null;
    onExpandClick?: () => void;
    isExpanded?: boolean;
    showBaseLayerToggle?: boolean;
    isFetching?: boolean;
}

export function MapControls({
    mapInstance,
    onExpandClick,
    isExpanded,
    showBaseLayerToggle = true,
    isFetching,
}: MapControlsProps) {
    // Don't render controls until the map instance is available.
    if (!mapInstance) {
        return null;
    }

    return (
        <div className="search--map-controls">
            {showBaseLayerToggle ? (
                <div className="left-controls">
                    {isExpanded ? <SearchFilterCombo size="sm" /> : null}

                    {isFetching ? (
                        <MapLoadingIndicator />
                    ) : (
                        // Fixed-size spacer keeps the controls row stable when
                        // the loading indicator isn't shown.
                        <div className="control-spacer" />
                    )}
                </div>
            ) : null}

            <div className="zoom-and-expand-controls">
                {typeof onExpandClick === 'function' &&
                typeof isExpanded === 'boolean' ? (
                    <div className="expand-controls">
                        <MapExpandButton
                            isExpanded={isExpanded}
                            onToggle={onExpandClick}
                            gaTrackingId="521046128589"
                            gaTrackingValue={isExpanded ? 'Show List' : 'Expanded'}
                        />
                    </div>
                ) : null}

                <MapZoomControls />
            </div>
        </div>
    );
}
